import React, { FC, useState, useEffect, useContext } from 'react'
import history from '../../../history'

import { isMobile } from 'react-device-detect'

import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericButton from '../../../GenericComponents/GenericButton'
import GenericCloseButton from '../../../GenericComponents/GenericCloseButton'
import GenericCard from '../../../GenericComponents/GenericMainCard'

interface DemoUserRedirectToSubModalInterface {
  closeModal: Function
}

const DemoUserRedirectToSubModal: FC<DemoUserRedirectToSubModalInterface> = ({
  closeModal,
}) => {
  return (
    <GenericCard
      flexDir={'column'}
      className="standard"
      width={'100%'}
      margin={' auto'}
    >
      <GenericCloseButton onClick={closeModal} />

      <GenericRow margin={'0% 0 3% 0'}>
        <GenericTextSpan fSize={'2rem'} fWeight={'bold'}>
          Odblokuj zawartość
        </GenericTextSpan>
      </GenericRow>

      <GenericRow>
        <GenericTextSpan
          fSize={'1.4rem'}
          margin={'3% 0 0 0'}
          fWeight={'normal'}
          width={isMobile ? '90%' : '60%'}
        >
          By uzyskać dostęp do zawartości aplikacji MIAZGA by FMW musisz
          posiadać subskrypcję aplikacji.
        </GenericTextSpan>
      </GenericRow>
      <GenericRow>
        <GenericButton
          width={'40%'}
          className="standard"
          margin={'4% auto'}
          justify={'center'}
          onClick={() => history.push('/wybierz-plan/sub')}
        >
          Kup subksrypcję
        </GenericButton>
      </GenericRow>
    </GenericCard>
  )
}

export default DemoUserRedirectToSubModal
